import API from "../../../apiService";
// console.log(API.service.defaults.baseURL);
const odontograms = {
  normal: { src: `${API.service.defaults.baseURL}/public/uploads/odontogram/normal.png`, alt: "normal" },
  normal2: { src: `${API.service.defaults.baseURL}/public/uploads/odontogram/normal2.png`, alt: "normal2" }
};
export default odontograms;
